export default "__VITE_ASSET__B$ah637Z__"